import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import classnames from 'classnames'
import ImmutableProptypes from 'react-immutable-proptypes'
import { OrderedMap, Map, List } from 'immutable'
import update from 'immutability-helper'
import { DragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import { connect as reduxConnect } from 'react-redux'
import Modal from 'react-modal'
import { browserHistory } from 'react-router'
import Moment from 'moment'
import { toast } from 'react-toastify'
import Select from 'react-select'
import 'react-toastify/dist/ReactToastify.css'

import {
  getTomorrowItems,
  setTomorrowItemsOrder,
  deleteTomorrowItem,
  createTomorrowItem,
  editTomorrowItem,
  checkTomorrowItem,
  undoTomorrowItem,
} from '_modules/tomorrow-items/actions'
import { updateSettings } from '_modules/settings/actions'
import { getTodayItems, createTodayItem } from '_modules/today-items/actions'
import { updateLastActivityAt } from '_modules/user/actions'
import { objectToArray, deepCopyJSON } from '_utils/helperFunction'
import { createGoogleCalendarURL, createICalendarEvent } from '_utils/addToCalendar'

import styles from './styles.css'
import OrderingCard from './ordering-card'
import AddItemModal from './add-item-modal'
import CalendarModal from './calendar-modal'
import EventFormModal from './event-form-modal'

const mapStateToProps = ({ user, tomorrowItems, todayItems, settings, log }) => ({
  tomorrowItems,
  todayItems,
  settings,
  log,
  user,
})

const mapDispatchToProps = {
  getTomorrowItems,
  setTomorrowItemsOrder,
  deleteTomorrowItem,
  createTomorrowItem,
  editTomorrowItem,
  updateLastActivityAt,
  getTodayItems,
  checkTomorrowItem,
  createTodayItem,
  updateSettings,
  undoTomorrowItem,
}

@DragDropContext(HTML5Backend)
class TomorrowItems extends PureComponent {
  static propTypes = {
    tomorrowItems: ImmutableProptypes.orderedMap,
    settings: ImmutableProptypes.map,
    log: ImmutableProptypes.map,
    user: ImmutableProptypes.map,
    todayItems: ImmutableProptypes.map,
    getTomorrowItems: PropTypes.func.isRequired,
    setTomorrowItemsOrder: PropTypes.func.isRequired,
    deleteTomorrowItem: PropTypes.func.isRequired,
    createTomorrowItem: PropTypes.func.isRequired,
    editTomorrowItem: PropTypes.func.isRequired,
    updateLastActivityAt: PropTypes.func.isRequired,
    getTodayItems: PropTypes.func.isRequired,
    checkTomorrowItem: PropTypes.func.isRequired,
    createTodayItem: PropTypes.func.isRequired,
    updateSettings: PropTypes.func.isRequired,
    undoTomorrowItem: PropTypes.func.isRequired,
  }

  static defaultProps = {
    tomorrowItems: new OrderedMap(),
    counter: new Map(),
    settings: new Map(),
    log: new Map(),
    user: new Map(),
    todayItems: new OrderedMap(),
  }

  undoToastId = null

  state = {
    cards: [],
    isModalOpen: false,
    isAddItemModal: false,
    isCalendarModal: false,
    isEventFormModal: false,
    isEditTitleModal: false,
    modalName: '',
    modalDatetime: null,
    modalDuration: 0.5,
    modalSection: 100,
    modalId: undefined,
    selectedOption: null,
    sectionName: '',
    sections: [
      { key: 0, sectionName: 'tomorrowSection0', name: 'Recurring', show: true },
      { key: 100, sectionName: 'tomorrowSection1', name: 'Tomorrow', show: true },
      { key: 200, sectionName: 'tomorrowSection2', name: 'Later', show: true },
      { key: 300, sectionName: 'tomorrowSection3', name: 'Much Later', show: true },
      { key: 400, sectionName: 'tomorrowSection4', name: 'Catch-All', show: true },
    ],
  }

  componentWillMount() {
    Modal.setAppElement('body')
    this.props.getTomorrowItems()
    this.props.getTodayItems(true)
    this.getState(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.user.get('lastActivityAt') !== nextProps.user.get('lastActivityAt')) {
      this.props.getTomorrowItems()
    }
    this.getState(nextProps)
  }

  componentWillUnmount() {
    toast.dismiss(this.undoToastId)
    this.props.clearError()
  }

  onKeyPress = event => {
    if (event.key === 'Enter') {
      this.onConfirmModal(event)
    }
  }

  onAddClick = e => {
    e.preventDefault()

    this.setState({
      isModalOpen: true,
      isAddItemModal: true,
    })
  }

  onRefreshClick = () => {
    this.props.getTomorrowItems()
  }

  onNameChange = e => {
    e.preventDefault()

    const { id, value } = e.target

    this.setState({
      modalName: value,
    })
  }

  onDatetimeChange = modalDatetime => {
    this.setState({ modalDatetime })
  }

  onDurationChange = e => {
    e.preventDefault()
    const { id, value } = e.target
    this.setState({
      modalDuration: value,
    })
  }

  onDropDownChange = e => {
    const { id, value } = e.currentTarget

    this.setState({
      [id]: value * 1,
    })
  }

  onSectionHeaderClick = key => {
    let foundIndex = -1
    foundIndex = this.state.sections.findIndex(ele => ele.key === key)
    if (foundIndex !== -1) {
      this.state.sections[foundIndex].show = !this.state.sections[foundIndex].show
      const sections = JSON.parse(JSON.stringify(this.state.sections))

      this.setState({ sections })
      this.props.getTomorrowItems(key)
    }
  }

  onCloseModal = e => {
    e.preventDefault()
    this.props.clearError()

    this.setState({
      isModalOpen: false,
      isEditTitleModal: false,
      isAddItemModal: false,
      isCalendarModal: false,
      isEventFormModal: false,
      modalName: '',
      modalId: undefined,
      modalSection: 100,
      selectedOption: null,
      sectionName: '',
    })
  }

  onConfirmModal = e => {
    if (e) {
      e.preventDefault()
    }
    this.props.clearError()

    const { settings } = this.props
    const { modalName, modalId, isEditTitleModal, sectionName, isEventFormModal } = this.state

    if (isEventFormModal) {
      this.handleCalendarClick('ics')
      return
    }

    if (!modalName) {
      this.props.displayError('Enter a name')
      return
    }

    // changing title
    if (isEditTitleModal) {
      const tempSettings = JSON.parse(JSON.stringify(settings.toJS()))
      // make sure new name does not match others
      if (
        tempSettings.tomorrowSection0 === modalName ||
        tempSettings.tomorrowSection1 === modalName ||
        tempSettings.tomorrowSection2 === modalName ||
        tempSettings.tomorrowSection3 === modalName ||
        tempSettings.tomorrowSection4 === modalName
      ) {
        this.props.displayError("Enter a name that isn't a duplicate")
        return
      }

      tempSettings[sectionName] = modalName
      this.props.updateSettings(tempSettings)
      this.setState({
        isModalOpen: false,
      })
    } else {
      // entering task
      if (modalId) {
        this.modifyTomorrowItem()
      } else {
        this.createTomorrowItem()
      }
    }

    this.setState({
      isModalOpen: false,
    })
  }

  getState = props => {
    const cards = objectToArray(props.tomorrowItems.toJS())
    const sectionNames = [
      props.settings.get('tomorrowSection0'),
      props.settings.get('tomorrowSection1'),
      props.settings.get('tomorrowSection2'),
      props.settings.get('tomorrowSection3'),
      props.settings.get('tomorrowSection4'),
    ]
    const sections = this.state.sections.map((ele, index) => {
      ele.name = sectionNames[index]
      return ele
    })
    this.setState({ cards, sections })
  }

  editCard = id => {
    const { cards } = this.state
    const card = cards.filter(c => c._id === id)[0]

    const selectedOption = this.selectOptions().find(option => option.value === card.section)

    this.setState({
      modalName: card.name,
      modalSection: card.section,
      modalId: card._id,
      isModalOpen: true,
      isAddItemModal: true,
      selectedOption,
    })
  }

  checkCard = id => {
    const now = new Date()
    const { cards } = this.state
    const card = cards.filter(c => c._id === id)[0]

    const { todayItems } = this.props
    // find last order in todayItems
    const order = objectToArray(todayItems.toJS()).reduce((prevVal, c) => {
      if (c.order > prevVal) {
        return c.order
      }
      return prevVal
    }, 0)

    const foundSameCard = objectToArray(todayItems.toJS()).filter(
      x =>
        x.name.toLowerCase() === card.name.toLowerCase() &&
        new Date(x.keptAt).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)
    )

    if (foundSameCard.length > 0) {
      this.props.displayError('Today item with the same name already exists')
    } else {
      const payload = {
        time: now,
        name: card.name,
        order: order + 1,
        tomorrowId: card.section != 0 ? id : null,
      }

      this.props.checkTomorrowItem(payload)
      this.props.getTodayItems()
      this.props.updateLastActivityAt({
        lastActivityAt: new Date(),
      })
    }
  }

  saveOrdering = () => {
    const { cards } = this.state

    const payload = cards.reverse().reduce((obj, item, index) => {
      const newObj = { ...obj }
      newObj[item._id] = index
      return newObj
    }, {})

    this.props.setTomorrowItemsOrder(payload)
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  moveCard = (dragIndex, hoverIndex) => {
    const { cards } = this.state

    const dragCard = cards[dragIndex]
    const hoverCard = cards[hoverIndex]

    const dragCardIndex = cards.findIndex(ele => dragCard._id === ele._id)
    const hoverCardIndex = cards.findIndex(ele => hoverCard._id === ele._id)

    this.setState(
      update(this.state, {
        cards: {
          $splice: [[dragCardIndex, 1], [hoverCardIndex, 0, dragCard]],
        },
      })
    )
  }

  shiftCard = id => {
    const { cards } = this.state
    const card = cards.filter(c => c._id === id)[0]

    const { todayItems } = this.props
    // find last order in todayItems
    const order = objectToArray(todayItems.toJS()).reduce((prevVal, c) => {
      if (c.order > prevVal) {
        return c.order
      }
      return prevVal
    }, 0)

    const foundSameCard = objectToArray(todayItems.toJS()).filter(
      x =>
        x.name.toLowerCase() === card.name.toLowerCase() &&
        new Date(x.keptAt).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)
    )

    if (foundSameCard.length > 0) {
      this.props.displayError('Today item with the same name already exists')
    } else {
      const payload = {
        name: card.name,
        order: order + 1,
      }

      this.props.createTodayItem(payload)

      //delete if not recurring task
      if (card.section !== 0) {
        this.props.deleteTomorrowItem({ id })
      }
      this.props.updateLastActivityAt({
        lastActivityAt: new Date(),
      })

      // notify success
      toast.success(`Added ${card.name} to Today`, {
        position: 'top-center',
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
      })
    }
  }

  undoCard = () => {
    this.props.undoTomorrowItem()
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
    toast.dismiss(this.undoToastId)
  }

  deleteCard = id => {
    this.props.deleteTomorrowItem({ id })

    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })

    const UndoMsg = ({ closeToast }) => (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
        }}
      >
        <div style={{ color: 'white', fontSize: 14, flex: 1, paddingLeft: 7 }}>
          Tomorrow Item Trashed
        </div>
        <button className={styles.undoButton} onClick={() => this.undoCard()}>
          <div style={{ color: '#F9DC5C', fontSize: 13 }}>UNDO</div>
        </button>
        <button onClick={closeToast} style={{ color: 'rgba(255,255,255,0.5)', fontSize: 12 }}>
          X
        </button>
      </div>
    )

    if (!toast.isActive(this.undoToastId)) {
      this.undoToastId = toast(<UndoMsg />, {
        className: styles['black-background'],
        position: toast.POSITION.BOTTOM_LEFT,
        autoClose: false,
        closeOnClick: false,
        closeButton: false,
      })
    }
  }

  moveToSectionCard = (id, section) => {
    const { cards } = this.state
    const card = cards.filter(c => c._id === id)[0]

    // find dupe in tasks page
    const dupe = cards.find(ele => ele.name === card.name && ele.section === section)
    if (dupe) {
      toast.error('Task already exists', {
        position: 'top-center',
        autoClose: 2000,
      })
      return
    }

    const payload = {
      id: card._id,
      name: card.name,
      order: card.order,
      section,
      moveSection: true,
    }
    this.props.editTomorrowItem(payload)

    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  modifyTomorrowItem = () => {
    const { modalName: name, modalId: id, modalSection: section, cards } = this.state

    const card = cards.filter(c => c._id === id)[0]
    const payload = {
      id,
      name,
      order: card.order,
      section,
    }
    this.props.editTomorrowItem(payload)

    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })

    this.resetScreen()
  }

  createTomorrowItem = () => {
    const { modalName: name, cards, modalSection: section } = this.state

    const order = cards.reduce((prevVal, card) => {
      if (card.order > prevVal) {
        return card.order
      }
      return prevVal
    }, 0)

    const payload = {
      name,
      order: order + 1,
      section,
    }

    this.props.createTomorrowItem(payload)

    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })

    this.resetScreen()
  }

  handleSectionTitleEditPress = section => {
    const { name, key, show, sectionName } = section

    this.setState({
      isModalOpen: true,
      modalName: name,
      isAddItemModal: true,
      isEditTitleModal: true,
      sectionName,
    })
  }

  onCalendarClick = payload => {
    const { name } = payload
    this.setState({
      isCalendarModal: true,
      isModalOpen: true,
      modalName: name,
    })
  }

  handleCalendarClick = type => {
    const { modalName: name, modalDatetime: datetime, modalDuration: duration } = this.state
    switch (type) {
      case 'gcal': {
        const url = createGoogleCalendarURL({ name })
        window.open(url, '_blank')
        this.resetScreen()
        break
      }
      case 'apple':
        this.setState({
          isCalendarModal: false,
          isEventFormModal: true,
          modalDatetime: new Moment().subtract(1, 'hours'),
        })
        break
      case 'outlook':
        this.setState({
          isCalendarModal: false,
          isEventFormModal: true,
          modalDatetime: new Moment().subtract(1, 'hours'),
        })
        break
      case 'ics':
        createICalendarEvent({ name, datetime, duration })
        this.resetScreen()
        break
      default:
    }
  }

  resetScreen = () =>
    this.setState({
      isModalOpen: false,
      modalName: '',
      modalId: undefined,
      modalSection: 100,
      selectedOption: null,
      isEditTitleModal: false,
      isAddItemModal: false,
      isCalendarModal: false,
      isEventFormModal: false,
    })

  renderCards = group =>
    group.map(card => {
      const { cards } = this.state
      const arrIndex = cards.findIndex(x => x._id === card._id)
      const hilight = this.props.location.state && this.props.location.state.id === card._id

      return (
        <li
          key={card._id}
          className={classnames(
            styles['Grid-cell'],
            styles.pause,
            hilight && styles.hilight,
            this.props.counter.get('status') === 'in progress' &&
              this.props.counter.get('name').toLowerCase() === card.name.toLowerCase() &&
              styles.disabled
          )}
        >
          <OrderingCard
            index={arrIndex}
            moveCard={this.moveCard}
            id={card._id}
            saveOrdering={this.saveOrdering}
            editCard={this.editCard}
            shiftCard={this.shiftCard}
            checkCard={this.checkCard}
            deleteCard={this.deleteCard}
            moveToSectionCard={this.moveToSectionCard}
            createCalendarCard={this.onCalendarClick}
            name={card.name}
            section={card.section}
          />
        </li>
      )
    })

  renderSections = () =>
    this.state.sections.map(section => {
      const { cards } = this.state
      const { name, key, show } = section
      return (
        <div key={name} style={{ width: 500 }}>
          <div className={classnames(styles.title, !show && styles.collapsed)}>
            <button onClick={() => this.onSectionHeaderClick(key)}>{name}</button>
            {name !== 'Recurring' && (
              <i
                className="fa fa-pencil"
                style={{ cursor: 'pointer' }}
                onClick={() => this.handleSectionTitleEditPress(section)}
              />
            )}
          </div>
          <ul>{show && this.renderCards(cards.filter(c => c.section === key))}</ul>
        </div>
      )
    })

  divRef = null

  selectOptions = () => {
    const { settings } = this.props
    return [
      { value: 0, page: 'tasks', section: 0, label: 'Recurring' },
      { value: 100, page: 'tasks', section: 100, label: settings.get('tomorrowSection1') },
      { value: 200, page: 'tasks', section: 200, label: settings.get('tomorrowSection2') },
      { value: 300, page: 'tasks', section: 300, label: settings.get('tomorrowSection3') },
      { value: 400, page: 'tasks', section: 400, label: settings.get('tomorrowSection4') },
    ]
  }

  handleChange = selectedOption => {
    this.setState({ selectedOption, modalSection: selectedOption.section })
  }

  render() {
    const {
      cards,
      isModalOpen,
      isEditTitleModal,
      isAddItemModal,
      isCalendarModal,
      isEventFormModal,
      modalName,
      modalDatetime,
      modalDuration,
      modalSection,
      selectedOption,
    } = this.state

    const customStyles = {
      control: (provided, state) => ({
        ...provided,
        backgroundColor: 'auto',
        border: ' 1px solid rgba(255,255,255,0.3)',
      }),
      placeholder: (provided, state) => ({ ...provided, fontSize: 16, color: 'white' }),
      singleValue: (provided, state) => ({ ...provided, fontSize: 16, color: 'white' }),
      input: (provided, state) => ({ ...provided, fontSize: 16, color: 'white' }),
      menu: (provided, state) => ({
        ...provided,
        backgroundColor: 'rgba(80,95,172,0.8)',
        fontSize: 16,
        color: 'white',
      }),
      option: (provided, { isFocused }) => {
        return {
          ...provided,
          color: isFocused ? 'black' : 'white',
        }
      },
    }

    const calendars = [
      {
        name: 'Google Calendar',
        function: () => this.handleCalendarClick('gcal'),
        icon: 'fa fa-google',
      },
      {
        name: 'Outlook Calendar',
        function: () => this.handleCalendarClick('outlook'),
        icon: 'fa fa-windows',
      },
      {
        name: 'Apple Calendar',
        function: () => this.handleCalendarClick('apple'),
        icon: 'fa fa-apple',
      },
    ]

    const selectItems = this.selectOptions()

    return (
      <div ref={div => (this.divRef = div)} className={classnames(styles.main)}>
        <div className={classnames(styles.listContainer)}>{this.renderSections()}</div>
        <div className={classnames(styles.buttonContainer)}>
          <button className={classnames(styles['add-button'])} onClick={this.onAddClick}>
            Add Item
          </button>
          <button className={classnames(styles['add-button'])} onClick={this.onRefreshClick}>
            Refresh
          </button>
        </div>
        <Modal
          isOpen={isModalOpen}
          className={classnames(styles.modal)}
          overlayClassName={classnames(styles.overlay)}
          onRequestClose={this.onCloseModal}
          shouldCloseOnOverlayClick
          bodyOpenClassName={classnames(styles['disable-body-scroll'])}
        >
          {isAddItemModal && (
            <AddItemModal
              inputValue={modalName}
              inputOnChange={this.onNameChange}
              inputPlaceholder="Name"
              inputKeyPress={this.onKeyPress}
              button1Name="SAVE"
              button2Name="CANCEL"
              button1Function={this.onConfirmModal}
              button2Function={this.onCloseModal}
              showSelect={!isEditTitleModal}
              selectValue={selectedOption}
              selectOnChange={this.handleChange}
              selectOptions={selectItems}
              selectCustomStyles={customStyles}
              placeholder={this.props.settings.get('tomorrowSection1')}
            />
          )}
          {isCalendarModal && <CalendarModal calendars={calendars} />}
          {isEventFormModal && (
            <EventFormModal
              nameValue={modalName}
              nameOnChange={this.onNameChange}
              dateValue={modalDatetime}
              dateOnChange={this.onDatetimeChange}
              durationValue={modalDuration}
              durationOnChange={this.onDurationChange}
              button1Name="SAVE"
              button2Name="CANCEL"
              button1Function={this.onConfirmModal}
              button2Function={this.resetScreen}
            />
          )}
        </Modal>
      </div>
    )
  }
}

export default reduxConnect(mapStateToProps, mapDispatchToProps)(TomorrowItems)



// WEBPACK FOOTER //
// ./src/views/tomorrow-items/index.js